export enum Species {
  // Core
  Andorian,
  Bajoran,
  Betazoid,
  Denobulan,
  Human,
  Tellarite,
  Trill,
  Vulcan,
  // Extended
  KlingonExt,
  RomulanExt,
  Borg,
  FerengiExt,
  CardassianExt,
  JemHadar,
  Vorta,
  // Beta Quadrant
  Ardanan,
  Benzite,
  Bolian,
  Deltan,
  Efrosian,
  Klingon,
  Chelon,
  Jelna,
  Risian,
  XindiArboreal,
  XindiPrimate,
  XindiReptilian,
  XindiInsectoid,
  Zakdorn,
  Reman,
  Orion,
  GornExt,
  // DS9
  Changeling,
  Ferengi,
  // TNG
  Android,
  // Alpha Quadrant
  Arbazan,
  Arkarian,
  Aurelian,
  Caitian,
  Cardassian,
  Edosian,
  FerengiAlpha,
  Grazerite,
  Haliian,
  Ktarian,
  Zaranite,
  Tzenkethi,
  // Gamma Quadrant
  Argrathi,
  ChangelingGamma,
  Dosi,
  Drai,
  Karemma,
  Lurian,
  Paradan,
  Rakhari,
  Skreeaa,
  SonA,
  Tosk,
  Wadi,
  // Delta Quadrant
  Ankari,
  Jye,
  LiberatedBorg,
  Lokirrim,
  Mari,
  Monean,
  Ocampa,
  Pendari,
  Sikarian,
  Talaxian,
  Turei,
  Zahl,
  // Voyager
  Hologram,
  // Klingon Core
  KlingonQuchHa,
  // Shackleton Expanse
  Akaru,
  CalMirran,
  Qofuari,
  VinShari,
  // IwdYearFive
  IQosa,
  Iotian,
  Tholian,

  // Tribble Player Character
  Tribble,

  // Discovery
  Kelpien,
  Barzan,
  Osnullus,
  Xahean,
  Saurian,
  CyberneticallyEnhanced,
  Baul,

  // should have been in Delta Quadrant, above...
  Kobali,
  Romulan,

  // Lower Decks
  Apergosian,
  Cetacean,
  Clicket,
  Exocomp,
  Gorn,
  Kaelon,
  Pakled,
  Tamarian,
  Kzinti,
  Anabaj,

  // Captain's Log
  Aenar,
  Bynar,
  Doopler,
  Horta,
  Illyrian,
  Kazon,
  Suliban,

  // Animated Series
  Aquan,
  Pandronian,
  Phylosian,
  Skorr,

  // Continuing Missions
  ElAurian,
  Yridian,
  Hupyrian,
  Talarian,
  Tiburonian,
  Napean,

  // Federation-Klingon War
  Arcadian,
  Ariolo,
  Betelgeusian,
  Coridanite,
  Megarite,

  // Species Book
  Breen,
  Brikar,
  Chameloid,
  ElAurian_2E,
  Exocomp_2E,
  Horta_2E,
  HumanAugment,
  Illyrian_2E,
  Kellerun,
  KlingonQuchHa_2E,
  Klowahkan,
  Kwejian,
  Lanthanite,
  Medusan,
  Nanokin,
  Nausicaan,
  BlueOrion,
  Terran,
  VauNAkat,
  Yridian_2E,
  XindiAquatic,

  Custom,
}
